<template>
    <van-popup v-model:show="show" position="bottom" @opened="handleOpened" @closed="handleClosed" :style="{
        minWidth: '100%',
        minHeight: '100%',
        zIndex: '10002'
    }">
        <div class="pop_container">
            <div class="headBar">
                <div class="appIcon"><img src="@/assets/themeFour/logo.png" alt=""></div>
                <div class="close_icon"> <img src="@/assets/loginRegister/close_icon.png" alt="" @click="close"></div>
            </div>

            <div class="register_container">

                <div class="form_container">
                    <div class="main_title">{{ dataSet?.signType == 0 ? $t('common.register') : $t('common.login') }}
                    </div>

                    <div v-if="dataSet?.signType == 0" class="content_text">{{ $t('loginRegister.alreadyAcc') }}
                        <span @click="changeSignType(1)">{{ $t('loginRegister.loginNow') }}</span>
                    </div>
                    <div v-if="dataSet?.signType == 1" class="content_text">{{ $t('loginRegister.dontHaveAcc') }}
                        <span @click="changeSignType(0)">{{ $t('loginRegister.registerNow') }}</span>
                    </div>

                    <!-- phone number field -->
                    <InputField v-model="phoneNumber" :isShowError="dataSet?.phoneValidationNotice"
                        @valueChanged="phoneNumberChange" :labelText="$t('profile.phoneNum')" :isshowFlag="true"
                        fieldType="number" />
                    <div>
                        <div v-if="dataSet?.phoneValidationNotice" class="errorNotice">
                            <van-icon name="warning-o" />
                            {{ $t('loginRegister.phoneFormat') }}
                        </div>
                    </div>

                    <!-- password fields -->
                    <InputField v-model="password" :isShowError="dataSet?.passwordValidationNotice"
                        @valueChanged="passwordChange" :isPassword="true" :labelText="$t('loginRegister.enterPassword')"
                        fieldType="password" />
                    <div v-if="dataSet?.passwordValidationNotice" class="errorNotice">
                        <van-icon name="warning-o" />
                        {{ $t('loginRegister.passwordForamt') }}
                    </div>
                    <InputField v-if="dataSet?.signType == 0" v-model="confirmPassword"
                        :isShowError="dataSet?.confirmPasswordValidationNotice || (dataSet?.password !== '' && dataSet?.confirmPassword !== '' && dataSet?.password !== dataSet?.confirmPassword)"
                        @valueChanged="confirmPasswordChange" :isPassword="true"
                        :labelText="$t('loginRegister.confirmPassword')" fieldType="password" />
                    <div v-if="dataSet?.confirmPasswordValidationNotice" class="errorNotice">
                        <van-icon name="warning-o" />
                        {{ $t('loginRegister.passwordForamt') }}
                    </div>
                    <div v-else-if="dataSet?.confirmPassword && dataSet?.password && dataSet?.confirmPassword !== dataSet?.password"
                        class="errorNotice">
                        <van-icon name="warning-o" />
                        {{ $t('loginRegister.differentPassword') }}
                    </div>

                    <!-- Captcha field -->
                    <CaptchaField v-if="dataSet?.isShowCaptcha" v-model="captcha" :captcha-img="dataSet?.captchaImg"
                        @valueChanged="captchaChage" @updateCaptcha="getCaptchaImageData"
                        :labelText="$t('loginRegister.captchaEnter')" />
                    <div v-if="dataSet?.signType == 0">
                        <!-- whatsapp OTP -->
                        <InputField v-if="dataSet?.showSMSOTP" v-model="smsOTP" @valueChanged="smsOTPChange"
                            ref="smsOTPRef" :labelText="$t('loginRegister.smsCode')" fieldType="number" :isOTP="true"
                            @getOtp="getSMSOTP" />
                        <!-- Whatsapp OTP -->
                        <InputField v-if="dataSet?.showWhatsappOTP" v-model="whatsappOTP"
                            @valueChanged="whatsappOTPChange" ref="whatsappOTPRef"
                            :labelText="$t('loginRegister.whatsappCode')" fieldType="number" :isOTP="true"
                            @getOtp="getWhatsappOTP" />
                        <!-- email OTP-->
                        <div v-if="dataSet?.showEmailOTP">
                            <InputField v-model="emailOTP" :isShowError="dataSet?.emailValidationNotice"
                                @valueChanged="emailChange" :labelText="$t('loginRegister.enteremail')"
                                fieldType="email" />
                            <div>
                                <div v-if="dataSet?.emailValidationNotice" class="errorNotice">
                                    {{ $t('loginRegister.emailFormat') }}
                                </div>
                            </div>

                            <InputField v-model="email" @valueChanged="emailOTPChange" ref="emailOTPRef"
                                :labelText="$t('loginRegister.emailCode')" fieldType="number" :isOTP="true"
                                @getOtp="getEmailOTP" />
                        </div>
                    </div>



                    <div class="human_verify" v-if="dataSet?.cloudFlareCaptchaEnabled && dataSet?.signType == 0">
                        <div ref="turnstileContainer"></div>
                    </div>

                    <div class="btn_container">
                        <MainButton v-if="dataSet?.signType == 0" :title="$t('common.register')" radius="5px !important"
                            :activeStatus="dataSet?.isRegisterBtnActive" @click="signUp" :isBtnLoading="props.dataSet.isLoading"
                            btn-padding="30px !important" />
                        <MainButton v-if="dataSet?.signType == 1" :title="$t('common.login')" radius="5px !important"
                            :activeStatus="dataSet?.isLoginBtnActive" @click="signIn(false)"  :isBtnLoading="props.dataSet.isLoading"
                            btn-padding="30px !important" />
                    </div>

                </div>

            </div>
        </div>
        <SliderCaptcha v-model="showSliderCaptcha" @success="handleCaptchaSuccess" />
    </van-popup>
</template>

<script setup lang="ts">
import { ref, nextTick, watch } from 'vue';
import InputField from './components/inputField.vue';
import CaptchaField from './components/captchaField.vue';
import { RegisterLoginData, startCountdown, stopLoading } from '@/view/loginRegister/supportScript';
import MainButton from '../components/common/mainButton.vue';
import SliderCaptcha from '@/themes/themeOne/components/sliderCaptcha.vue';

const props = defineProps<{
    dataSet: RegisterLoginData
}>()
const emailOTPRef = ref()
const smsOTPRef = ref()
const whatsappOTPRef = ref()
const turnstileContainer = ref()
const turnstileWidgetId = ref('')
const turnstileRetryCount = ref(0)
const showSliderCaptcha = ref(false)
const currentAction = ref<'signIn' | 'signUp'>('signUp')
const show = ref(props.dataSet.show)
const phoneNumber = ref(props.dataSet.phoneNumber)
const email = ref(props.dataSet.email)
const password = ref(props.dataSet.password)
const confirmPassword = ref(props.dataSet.confirmPassword)
const smsOTP = ref(props.dataSet.smsOTP)
const whatsappOTP = ref(props.dataSet.whatsappOTP)
const emailOTP = ref(props.dataSet.emailOTP)
const captcha = ref(props.dataSet.captcha)

const emits = defineEmits(['open', 'close', 'changeSignType', 'phoneNumberChange', 'smsOTPChange', 'whatsappOTPChange', 'emailChange', 'emailOTPChange', 'passwordChange', 'confirmPasswordChange', 'captchaChage', 'signIn', 'signUp', 'getCaptchaImageData', 'getSMSOTP', 'getWhatsappOTP', 'getEmailOTP', 'turnstileTokenChange', 'turnstile-error'])

const open = (type: number) => {
    emits('open', type)
}

const renderTurnstile = () => {
    nextTick(() => {
        if (turnstileContainer.value && !turnstileWidgetId.value && (window as any).turnstile) {
            try {
                turnstileWidgetId.value = (window as any).turnstile.render(turnstileContainer.value, {
                    sitekey: props.dataSet.cloudFlareSiteKey,
                    theme: 'dark',
                    retry: 'never',
                    callback: (token: string) => {
                        emits('turnstileTokenChange', token)
                    },
                    'error-callback': () => {
                        emits('turnstile-error', 'error');
                        if (turnstileRetryCount.value < 3) {
                            turnstileRetryCount.value++;
                            if (turnstileWidgetId.value) (window as any).turnstile.reset(turnstileWidgetId.value);
                        }
                    },
                    'expired-callback': () => {
                        emits('turnstileTokenChange', '');
                    }
                });
            } catch (e) {
                console.error('Turnstile render error:', e);
            }
        }
    })
}

const removeTurnstile = () => {
    if (turnstileWidgetId.value && (window as any).turnstile) {
        try {
            (window as any).turnstile.remove(turnstileWidgetId.value);
        } catch (e) {
            console.error('Turnstile remove error:', e);
        }
        turnstileWidgetId.value = '';
        emits('turnstileTokenChange', '');
    }
}

const resetTurnstile = () => {
    if (turnstileWidgetId.value && (window as any).turnstile) {
        try {
            (window as any).turnstile.reset(turnstileWidgetId.value);
        } catch (e) {
            console.error('Turnstile reset error:', e);
        }
        emits('turnstileTokenChange', '');
    }
}

const handleOpened = () => {
    if (props.dataSet.cloudFlareCaptchaEnabled && props.dataSet.signType == 0) {
        renderTurnstile()
    }
}

const handleClosed = () => {
    turnstileRetryCount.value = 0;
    removeTurnstile()
}

watch(() => props.dataSet.cloudFlareCaptchaEnabled, (newVal) => {
    if (newVal && props.dataSet.signType == 0) {
        renderTurnstile()
    } else {
        removeTurnstile()
    }
})

watch(() => props.dataSet.signType, (newVal) => {
    if (props.dataSet.cloudFlareCaptchaEnabled) {
        if (newVal == 0) {
            renderTurnstile()
        } else {
            removeTurnstile()
        }
    }
})

const close = () => {
    emits('close')
}

const changeSignType = (value: number) => {
    emits('changeSignType', value)
}

const phoneNumberChange = (value: string) => {
    emits('phoneNumberChange', value)
}
const smsOTPChange = (value: string) => {
    emits('smsOTPChange', value)
}
const whatsappOTPChange = (value: string) => {
    emits('whatsappOTPChange', value)
}
const emailChange = (value: string) => {
    emits('emailChange', value)
}

const emailOTPChange = (value: string) => {
    emits('emailOTPChange', value)
}

const passwordChange = (value: string) => {
    emits('passwordChange', value)
}

const confirmPasswordChange = (value: string) => {
    emits('confirmPasswordChange', value)
}
const captchaChage = (value: string) => {
    emits('captchaChage', value)
}
const signIn = (isReg: boolean) => {
    emits('signIn', isReg)
}
const signUp = () => {
    if (props.dataSet.sliderEnabled) {
        currentAction.value = 'signUp';
        showSliderCaptcha.value = true;
    } else {
        emits('signUp');
    }
}

const handleCaptchaSuccess = (data: any) => {
    if (currentAction.value === 'signUp') {
        emits('signUp', data);
    } else {
        emits('signIn', false, data);
    }
}
const getCaptchaImageData = () => {
    emits('getCaptchaImageData')
}


const getSMSOTP = () => {
    emits('getSMSOTP')

}

const getWhatsappOTP = () => {
    emits('getWhatsappOTP')

}

const getEmailOTP = () => {
    emits('getEmailOTP')
}

const handleStartCountdown = (type: 'sms' | 'whatsapp' | 'email') => {
    startCountdown({ sms: smsOTPRef, whatsapp: whatsappOTPRef, email: emailOTPRef }, type)
}

const handleStopLoading = (type: 'sms' | 'whatsapp' | 'email') => {
    stopLoading({ sms: smsOTPRef, whatsapp: whatsappOTPRef, email: emailOTPRef }, type)
}

watch(() => props.dataSet, (newDataSet) => {
    phoneNumber.value = newDataSet.phoneNumber;
    email.value = newDataSet.email;
    password.value = newDataSet.password;
    confirmPassword.value = newDataSet.confirmPassword;
    smsOTP.value = newDataSet.smsOTP;
    whatsappOTP.value = newDataSet.whatsappOTP;
    emailOTP.value = newDataSet.emailOTP;
    captcha.value = newDataSet.captcha;
}, { deep: true });

defineExpose({
    handleStartCountdown,
    handleStopLoading,
    resetTurnstile
})
</script>
<style scoped>
.van-popup {
    backdrop-filter: blur(3px);
    -webkit-backdrop-filter: blur(3px);
    background: transparent;
    -ms-overflow-style: none;
    scrollbar-width: none;
    overflow-y: auto;
    width: 100%;
}

.register_container {
    display: flex;
    /* align-items: center; */
    /* justify-content: center; */
    flex-direction: column;
    min-height: 85vh;
    padding: 5% 0;
    background: rgb(0, 89, 88);
    box-shadow: 0 2px 0 0 rgb(13, 176, 174) inset;
    filter: drop-shadow(0px -14px 60px rgba(5, 121, 119, 0.4));
    fill: #1B233D;
    border-radius: 20px 20px 0 0;
    margin-top: 10%;
    padding: 20px;
}

.form_container {
    backdrop-filter: blur(4px) !important;
    border-radius: 20px;
    width: 100%;
}

.headBar {
    display: flex;
    flex-direction: row;
    padding: 20px 15px;
}

.close_icon {
    display: flex;
    justify-content: right;
    width: 20%;
}

.close_icon img {
    width: 22px;
    padding: 8px;
    background: #ffffff36;
    border-radius: 30px;
}

.appIcon {
    width: 80%;
}

.appIcon img {
    width: 150px;
}

.main_title {
    font-weight: bold;
    font-size: 35px;
    color: #FFFFFF;
    padding: 10px 0;
}

.content_text {
    font-weight: 500;
    font-size: 16px;
    color: rgba(255, 255, 255, .4);
    padding: 0 0 25px;
}

.content_text span {
    color: rgb(245, 200, 76);
    font-weight: bold;
}

.human_verify {
    margin: 10px 0 0;
    display: flex;
    justify-content: center;
}

.errorNotice {
    color: rgb(229, 64, 33);
    font-size: 15px;
    padding: 0 10px;
    font-weight: 500;
}

.btn_container {
    padding-top: 25px;
}

.checkBoxContainer {
    padding: 10px 10px 0;
}

.checkBoxContainer>>>.van-checkbox__label {
    color: #fff;
    padding: 5px;
}

.checkBoxContainer>>>.van-checkbox__icon--checked .van-icon {
    background-color: #FF780D !important;
    border-color: #FF780D !important;

}
</style>